/**
 * Bug Report Service
 *
 * Handles submission of bug reports to the backend API.
 */

import { apiRequest, handleApiResponse } from './api';

/**
 * Submit a bug report
 *
 * @param {Object} bugReport - The bug report data
 * @param {string} bugReport.category - Bug category (ui, calculation, performance, data, other)
 * @param {string} bugReport.description - Bug description
 * @param {string} bugReport.screenshot - Base64 encoded screenshot
 * @param {Object} currentUser - Firebase user object for auth
 * @returns {Promise<Object>} - Response with bug_id and status
 */
export async function submitBugReport(bugReport, currentUser) {
    const payload = {
        category: bugReport.category,
        description: bugReport.description,
        screenshot: bugReport.screenshot,
        url: window.location.href,
        user_agent: navigator.userAgent,
        app_version: process.env.REACT_APP_VERSION || '1.0.0'
    };

    const response = await apiRequest('/api/v1/bug-reports', {
        method: 'POST',
        body: JSON.stringify(payload)
    }, currentUser);

    return handleApiResponse(response);
}

const bugReportService = {
    submitBugReport
};

export default bugReportService;
